<template>

  <main class="main">

    <the-nav-titles></the-nav-titles>

    <div class="container">

      <h1 class="title title_h1">{{ title }}</h1>

    </div>

    <div
      v-if="!loaded"
      class="loader"
    ></div>

    <template v-else>

      <div class="container">

        <div class="layout layout_default-page">

          <div class="layout__item">

            <h2 class="title title_h2">{{ section01.title }}</h2>

          </div>

          <div class="layout__item">

            <p
              v-html="section01.desc"
              class="lead lead_top"
            ></p>

          </div>

        </div>

      </div>

      <img

        :src="images[0].src"
        :alt="images[0].title"
        class="image image_about-us"
      >

      <div class="container">

        <div class="layout layout_default-page section2">

          <div class="layout__item">

            <h2 class="title title_h2">{{ section02.title }}</h2>

          </div>

          <div class="layout__item">

            <p
              v-html="section02.desc"
              class="lead lead_default"
            ></p>

            <div class="facts">

              <div
                v-for="(value, key) in facts"
                class="facts-item"
              >

                <div class="facts-item__indicator">{{ value }}</div>

                <div class="facts-item__caption">{{ key }}</div>

              </div>

            </div>

          </div>

        </div>

        <div class="layout layout_default-page section3">

          <div class="layout__item">

            <h2 class="title title_h2">{{ section03.title }}</h2>

          </div>

          <div class="layout__item">

            <p
              v-html="section03.desc"
              class="lead lead_default"
            ></p>

            <div class="clients">

              <div
                      v-for="src in certificate"
                      class="client"
              >

                <img class="client__logo" :src="src">

              </div>

            </div>

          </div>

        </div>

        <div class="layout layout_default-page section4">

          <div class="layout__item">

            <h2 class="title title_h2">{{ section04.title }}</h2>

          </div>

          <div class="layout__item">

            <p
              v-html="section04.desc"
              class="lead lead_default"
            ></p>

            <div class="clients">

              <div
                      v-for="src in logotypes"
                      class="client"
              >

                <img class="client__logo" :src="src">

              </div>

            </div>

          </div>

        </div>

        <div class="layout layout_default-page">

          <div class="layout__item">

            <h2 class="title title_h2">{{ section05.title }}</h2>

          </div>

          <div class="layout__item">

            <p
                    v-html="section05.desc"
                    class="lead lead_default"
            ></p>

          </div>

        </div>

      </div>

      <img

        :src="images[1].src"
        :alt="images[1].title"
        class="image image_about-us"
      >

      <div class="container">

        <div class="layout layout_default-page">

          <div class="layout__item"></div>

          <div class="layout__item">

            <p class="lead lead_default">Lavora con noi.</p>

            <router-link class="button button_default" to="/career">Scopri le nostre possibilità</router-link>

          </div>

        </div>

      </div>

    </template>

  </main>

</template>

<script>
  import TheNavTitles from '@/components/TheNavTitles';

  export default {
    name: 'AboutUsPage',

    components: {
      TheNavTitles,
    },

    data() {
      return {
        title: 'Professionals',
        logotypes: [],
        images: [
          {
            title: null,
            src: null,
          },
          {
            title: null,
            src: null,
          },
        ],
        certificate: [],
        section01: {
          title: null,
          desc: null,
        },
        section02: {
          title: null,
          desc: null,
        },
        section03: {
          title: null,
          desc: null,
        },
        section04: {
          title: null,
          desc: null,
        },
        section05: {
          title: null,
          desc: null,
        },
        facts: {
          offices: 2,
          warehouses: 4,
          storage: 44,
          vans: 60,
          trucks: 4,
        },
        loaded: false,
      };
    },

    created() {
      this.fetchData();
    },

    methods: {
      fetchData() {
        this.$http.get('/static/api/about.json')

        .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.section01 = data.section01;
        this.section02 = data.section02;
        this.section03 = data.section03;
        this.section04 = data.section04;
        this.section05 = data.section05;

        console.log('this.section05', this.section05);

        this.logotypes = data.logotypes;
        this.images = data.images;

        this.certificate = data.certificate;

        this.loaded = true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/about-us/Index.vue